export default [
  {
    url: "/dashboard",
    name: "ダッシュボード",
    icon: "HomeIcon",
    i18n: 'Dashboard',
    slug: 'dashboard',
    index: 1,
  },
  {
    url: '/system-notifications',
    name: 'お知らせ一覧',
    icon: 'BellIcon',
    unreadNum: 0,
    i18n: 'Notifications',
    slug: 'notification',
    index: 1,
  },
  {
    url: "/chat",
    name: "チャット",
    icon: "MessageSquareIcon",
    unreadNum: 0,
    i18n: 'チャット',
    slug: 'chat',
    index: 1,
  },
  {
    url: '/box/',
    name: 'お問い合わせ一覧',
    icon: 'BoxIcon',
    i18n: 'お問い合わせ一覧',
    slug: 'box',
    level: 1,
    index: 2,
    show: true,
    submenu: [
      {
        name: "お問い合わせ一覧",
        url:"/box",
        slug: 'box'
      },
    ]
  },
  {
    url: '/telephone/',
    name: '電話一覧',
    icon: 'PhoneCallIcon',
    i18n: '電話一覧',
    slug: 'telephone',
    level: 1,
    index: 3,
    show: true,
    submenu: [
      {
        name: "電話一覧",
        url:"/telephone",
        slug: 'telephone'
      },
    ]
  },
]
